import Vue from 'vue'
import { Component, Mixins } from 'vue-property-decorator'
import ZinusCalendarBase from '../Base/ZinusCalendarBase'

@Component 
export default class ZinusCalendarWebpart extends Mixins(ZinusCalendarBase) {
    
}
